import(/* webpackMode: "eager" */ "/vercel/path0/app/[lng]/page.tsx");
